import { styled } from '@mui/material/styles';

import { CIRCULAR_PROGRESS_SIZE_PX } from 'theme/components/circular-progress';

import Icons from 'assets/icons';

export const CompletedDisc = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: CIRCULAR_PROGRESS_SIZE_PX.medium,
  height: CIRCULAR_PROGRESS_SIZE_PX.medium,
  borderRadius: '50%',
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.common.white,
}));

export const CompletedCheckIcon = styled(Icons.CheckOld)(({ theme }) => ({
  display: 'block',
  width: theme.spacing(1.5),
  height: theme.spacing(1.5),
}));
